import { IPublicClientApplication } from '@azure/msal-browser'
import axios from 'axios'
import { protectedResources } from '../authConfig'
import { Device } from '../models/Device'
import { OnboardingDevice } from '../models/Onboarding/OnboardingDevice'
import {
  authorizedDelete,
  authorizedPatch,
  authorizedPost,
} from '../utils/authUtils'

export const fetchDeviceById = async (id: string): Promise<Device> => {
  const baseUrl = process.env.REACT_APP_BASE_API_URL
  const response = await axios.get<Device>(`${baseUrl}/devices/${id}`)
  return response.data
}

export const createDevice = async (
  device: Device,
  instance: IPublicClientApplication,
): Promise<Device> => {
  const baseUrl = process.env.REACT_APP_BASE_API_URL
  return await authorizedPost(
    instance,
    `${baseUrl}/devices`,
    device,
    protectedResources.scopes.read,
  )
}

export const linkDeviceToLocation = async (
  deviceCode: string,
  locationId: number,
  instance: IPublicClientApplication,
): Promise<Device> => {
  const baseUrl = process.env.REACT_APP_BASE_API_URL
  return await authorizedPost(
    instance,
    `${baseUrl}/devices/link`,
    {
      locationId: locationId,
      deviceCode: deviceCode,
    },
    protectedResources.scopes.read,
  )
}

export const updateDevice = async (
  device: Partial<OnboardingDevice>,
  instance: IPublicClientApplication,
): Promise<OnboardingDevice> => {
  const baseUrl = process.env.REACT_APP_BASE_API_URL
  return await authorizedPatch<OnboardingDevice>(
    instance,
    `${baseUrl}/devices/${device.id}`,
    device,
    protectedResources.scopes.read,
  )
}

export const updateDeviceVisibility = async (
  device: Device,
  instance: IPublicClientApplication,
): Promise<Device> => {
  const baseUrl = process.env.REACT_APP_BASE_API_URL
  return await authorizedPatch<Device>(
    instance,
    `${baseUrl}/devices/${device.id}`,
    device,
    protectedResources.scopes.read,
  )
}

export const deleteDevice = async (
  device: Device,
  instance: IPublicClientApplication,
): Promise<void> => {
  const baseUrl = process.env.REACT_APP_BASE_API_URL
  await authorizedDelete(
    instance,
    `${baseUrl}/devices/${device.id}`,
    protectedResources.scopes.read,
  )
}
